import React, { useRef } from "react";
import { useHomeContext } from "@/context/homeContext";
import dynamic from "next/dynamic";
import GuestTitle from "./GuestTitle";

const GuestDropdown = dynamic(() => import("../Listing/GuestDropdown"), {
  ssr: false,
});

const GuestsDropdown = ({ showGuest, setShowGuest }) => {
  const refGuest = useRef(null);
  const { filterForm, setFilterForm } = useHomeContext();

  const toggleGuest = () => {
    setShowGuest(!showGuest);
  };
  return (
    <div
      ref={refGuest}
      className="relative w-full mb-2 lg:w-1/4 xsm:w-1/2 lg:mb-0"
    >
      <GuestTitle toggleGuest={toggleGuest} />
      {showGuest && (
        <GuestDropdown
          refOne={refGuest}
          filterForm={filterForm}
          setFilterForm={setFilterForm}
          toggleGuest={toggleGuest}
        />
      )}
    </div>
  );
};

export default GuestsDropdown;
